<i18n>
{
  "fr": {
    "businesses": "Entreprises",
    "accounts-search": "Comptes utilisateurs",
    "questionnaire-esg": "Questionnaire ESG",
    "logout-btn": "Déconnexion",
    "change-lang-btn": "English",
    "privacy-policy-btn" : "Politique de confidentialité",
    "privacy-policy-url" : "https://coreplatform.ca/core-politique-de-protection-des-renseignements-personnels-et-politique-de-confidentialite"
  },
  "en": {
    "businesses": "Businesses",
    "accounts-search": "User accounts",
    "questionnaire-esg": "ESG Questionnaire",
    "logout-btn": "Log out",
    "change-lang-btn": "Français",
    "privacy-policy-btn" : "Confidentiality Policy",
    "privacy-policy-url" : "https://coreplatform.ca/core-politique-de-protection-des-renseignements-personnels-et-politique-de-confidentialite"
  }
}
</i18n>

<template>
  <b-menu :activable="false">
    <b-menu-list>
      <!-- Nom de l'utilisateur -->
      <b-menu-item
        class="has-text-weight-semibold"
        icon="user"
        tag="router-link"
        to="#"
        :active="isCurrentPage('URL_ACCOUNT_USER_PROFILE')"
        :disabled="true"
        :label="name"
      ></b-menu-item>
    </b-menu-list>

    <hr class="my-2" />

    <b-menu-list>
      <b-menu-item
        :label="$t('businesses')"
        :active="isCurrentPage('URL_BUSINESS_LIST')"
        tag="router-link"
        :to="{ name: $consts.urls.URL_BUSINESS_LIST }"
      />
      <b-menu-item
        :label="$t('accounts-search')"
        :active="isCurrentPage('URL_ACCOUNTS_SEARCH')"
        tag="router-link"
        :to="{ name: $consts.urls.URL_ACCOUNTS_SEARCH }"
      />
      <b-menu-item
        :label="$t('questionnaire-esg')"
        :active="isCurrentPage('URL_QUESTIONNAIRE_ESG_ADMIN')"
        tag="router-link"
        :to="{ name: $consts.urls.URL_QUESTIONNAIRE_ESG_ADMIN }"
      />
    </b-menu-list>

    <hr class="my-2" />

    <b-menu-list>
      <!-- Lien de la politique de confidentialité -->
      <b-menu-item :label="$t('privacy-policy-btn')" tag="a" :href="$t('privacy-policy-url')" target="_blank"></b-menu-item>
      <!-- Lien de déconnexion -->
      <b-menu-item :label="$t('logout-btn')" @click="logout"></b-menu-item>
      <!-- Lien de changement de langue -->
      <b-menu-item :label="$t('change-lang-btn')" @click="changeLang"></b-menu-item>
    </b-menu-list>
  </b-menu>
</template>

<script>
import AuthentificationService from '@/services/authentification'
import i18n from '@/helpers/i18n'

export default {
  methods: {
    changeLang() {
      i18n.changeLang()
      this.setSuperAdminLanguage()
    },
    async setSuperAdminLanguage() {
      if (!this.currentUserId) return

      await this.$apollo.mutate({
        mutation: this.$options.mutation.UpdateUserLanguage,
        variables: {
          userId: this.currentUserId,
          language: { value: i18n.userLanguage() }
        }
      })

      this.$success()
    },
    logout: AuthentificationService.logout,
    isCurrentPage: function (pageKey) {
      return this.$route.name === this.$consts.urls[pageKey]
    }
  },
  computed: {
    name: function () {
      return this.me ? `${this.me.profile.firstName} ${this.me.profile.lastName}` : ''
    },
    currentUserId() {
      return this.me ? this.me.id : null
    }
  },
  apollo: {
    me: {
      query() {
        return this.$options.query.NavSuperAdmin_MyProfile
      }
    }
  }
}
</script>

<graphql>
query NavSuperAdmin_MyProfile {
  me {
    id
    profile {
      id
      firstName
      lastName
    }
  }
}

mutation UpdateUserLanguage($userId: ID!, $language: UserLanguageMaybe) {
  updateUserProfile(input: { userId: $userId, language: $language }) {
    user {
      id
      profile {
        id
        language
      }
    }
  }
}
</graphql>